import styled from 'styled-components';
import { Button } from 'antd';

export const Action = styled(Button)`
  margin: 0 2.5px;
  float: right;
`;